var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-panel-label"},[_vm._v(" "+_vm._s(_vm.titleText)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }